const STEPS = [
  { n: "01", t: "Tell us about you", b: "Name, email, phone, state. Thirty seconds, no account, no CV required to start." },
  { n: "02", t: "A recruiter matches you", b: "A real person reviews your profile and lines you up with employers hiring in your field and state." },
  { n: "03", t: "Interview & get hired", b: "We introduce you directly. No middlemen, no applicant fees — just a remote job that fits your life." },
];

export default function HowItWorks() {
  return (
    <section className="py-16 md:py-24 bg-[#0F2A1F] text-white" data-testid="home-how-it-works">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="text-[11px] tracking-[0.25em] uppercase text-[#D4AF37] font-bold">How it works</div>
        <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight max-w-3xl">From "just browsing" to "I start Monday" in three steps.</h2>
        <ol className="mt-10 md:mt-14 grid md:grid-cols-3 gap-4 md:gap-6">
          {STEPS.map((s) => (
            <li key={s.n} className="relative rounded-2xl bg-white/[0.05] ring-1 ring-white/10 p-6 md:p-8 hover:bg-white/[0.08] transition-colors">
              <div className="font-serif text-6xl font-bold text-[#D4AF37]/90 leading-none">{s.n}</div>
              <h3 className="mt-5 text-2xl font-bold">{s.t}</h3>
              <p className="mt-2 text-sm md:text-base text-white/70 leading-relaxed">{s.b}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
